import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { robustFetch } from './utils/apiUtils';
import SocialLinks from "./components/SocialLinks";
import { API_ENDPOINTS } from './config/api';

const APPS = [
    { id: 'pomodoro', name: 'Pomodoro', path: '/app-store/pomodoro' },
    { id: 'typewriting', name: 'Typewriting', path: '/app-store/typewriting' },
];

export default function Footer(){
    const navigate = useNavigate();
    const [blogCategories, setBlogCategories] = useState([]);

    useEffect(() => {
        // Fetch Blog Categories
        robustFetch(API_ENDPOINTS.BLOG.CATEGORIES)
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data)) setBlogCategories(data);
                else if (data && data.success && Array.isArray(data.data)) setBlogCategories(data.data);
            })
            .catch(() => {});
    }, []);

    const handleBlogCategoryClick = (category) => {
        window.location.href = `https://blog.harivishnu.in/category/${category.slug || category.name?.toLowerCase().replace(/\s+/g, '-')}`;
    };

    return(
        <div className="global-footer flex w-95 m-2 flex-col items-center justify-center overflow-hidden bg-hover rounded-[25px] border-[5px] border-gray-666">
            <div className="flex w-full items-start gap-16 px-8 py-12 lg:gap-12 lg:px-8 lg:py-10 max-[900px]:flex-col max-[900px]:gap-12 max-[900px]:px-6 max-[900px]:py-8 xs:px-6 xs:py-8">
                <div className="flex-1 flex flex-col gap-4">
                    <div className="w-full flex items-center gap-[15px]">
                        <a href="https://www.harivishnu.in/">
                            <img className="w-[50px] h-[50px] object-contain rounded-[12px] border-[1.5px] border-gray-666 transition-all duration-300" src="/images/home_images/Logo_Transparent.png" alt="Hari Vishnu Logo"/>
                        </a>
                        <h3 className="text-4xl font-extrabold text-text m-0">Hari Vishnu</h3>
                    </div>
                    <SocialLinks noShadow />
                    <a href="#Top" className="flex items-center gap-[5px] w-fit mt-[15px] no-underline text-text text-[0.95rem] font-semibold opacity-80 transition-all duration-300 hover:opacity-100 hover:text-primary-cyan hover:-translate-y-0.5" title="Back to Top">
                        <span>Go to Top</span>
                        <i className="fi fi-rr-arrow-small-up text-[1.2rem] flex items-center"></i>
                    </a>
                </div>

                <div className="flex-1 grid grid-cols-4 gap-2 lg:grid-cols-4 max-[640px]:w-full max-[640px]:grid-cols-2 max-[640px]:gap-y-8">
                    <div className="flex flex-col">
                        <a href="https://blog.harivishnu.in" className="no-underline"><h3 className="text-[1.1rem] font-bold text-primary-cyan mb-2 cursor-pointer uppercase tracking-wider transition-colors duration-300 hover:text-text">Blog</h3></a>
                        <ul className="list-none p-0 m-0 flex flex-col gap-[0.7rem]">
                            {blogCategories.length > 0 ? blogCategories.slice(0, 5).map(cat => (
                                <a key={cat._id} href={`https://blog.harivishnu.in/category/${cat.slug || cat.name?.toLowerCase().replace(/\s+/g, '-')}`} className="no-underline">
                                    <li className="text-[0.95rem] text-text opacity-80 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis transition-all duration-200 hover:opacity-100 hover:text-primary-cyan hover:pl-[1px]">
                                        {cat.name}
                                    </li>
                                </a>
                            )) : (
                                <>
                                    <a href="https://blog.harivishnu.in/category/technology" className="no-underline"><li className="text-[0.95rem] text-text opacity-80 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis transition-all duration-200 hover:opacity-100 hover:text-primary-cyan hover:pl-[1px]">Technology</li></a>
                                    <a href="https://blog.harivishnu.in/category/lifestyle" className="no-underline"><li className="text-[0.95rem] text-text opacity-80 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis transition-all duration-200 hover:opacity-100 hover:text-primary-cyan hover:pl-[1px]">Lifestyle</li></a>
                                </>
                            )}
                            <a href="https://blog.harivishnu.in" className="no-underline"><li className="text-[0.95rem] text-text opacity-80 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis transition-all duration-200 hover:opacity-100 hover:text-primary-cyan hover:pl-[1px]">View All</li></a>
                        </ul>
                    </div>

                    <div className="flex flex-col">
                        <a href="https://podcast.harivishnu.in" className="no-underline"><h3 className="text-[1.1rem] font-bold text-primary-cyan mb-2 cursor-pointer uppercase tracking-wider transition-colors duration-300 hover:text-text">Podcast</h3></a>
                        <ul className="list-none p-0 m-0 flex flex-col gap-[0.7rem]">
                            <a href="https://podcast.harivishnu.in" className="no-underline"><li className="text-[0.95rem] text-text opacity-80 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis transition-all duration-200 hover:opacity-100 hover:text-primary-cyan hover:pl-[1px]">All Episodes</li></a>
                        </ul>
                    </div>

                    <div className="flex flex-col">
                        <a href="https://store.harivishnu.in" className="no-underline"><h3 className="text-[1.1rem] font-bold text-primary-cyan mb-2 cursor-pointer uppercase tracking-wider transition-colors duration-300 hover:text-text">Shop</h3></a>
                        <ul className="list-none p-0 m-0 flex flex-col gap-[0.7rem]">
                            <a href="https://store.harivishnu.in" className="no-underline"><li className="text-[0.95rem] text-text opacity-80 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis transition-all duration-200 hover:opacity-100 hover:text-primary-cyan hover:pl-[1px]">View All</li></a>
                        </ul>
                    </div>

                    <div className="flex flex-col">
                        <a href="https://apps.harivishnu.in" className="no-underline"><h3 className="text-[1.1rem] font-bold text-primary-cyan mb-2 cursor-pointer uppercase tracking-wider transition-colors duration-300 hover:text-text">App Store</h3></a>
                        <ul className="list-none p-0 m-0 flex flex-col gap-[0.7rem]">
                            {APPS.map(app => (
                                <a key={app.id} href={`https://apps.harivishnu.in${app.path.replace(/^\/app-store/, '')}`} className="no-underline">
                                    <li className="text-[0.95rem] text-text opacity-80 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis transition-all duration-200 hover:opacity-100 hover:text-primary-cyan hover:pl-[1px]">
                                        {app.name}
                                    </li>
                                </a>
                            ))}
                            <a href="https://apps.harivishnu.in" className="no-underline"><li className="text-[0.95rem] text-text opacity-80 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis transition-all duration-200 hover:opacity-100 hover:text-primary-cyan hover:pl-[1px]">All Apps</li></a>
                        </ul>
                    </div>
                </div>
            </div>

            <hr className="h-px w-[96%] mx-auto bg-slider border-0 opacity-50" />

            <div className="flex items-center justify-between w-full px-10 py-6 box-border sm:flex-col sm:items-start sm:gap-4 sm:px-6 sm:py-6 xs:flex-col xs:items-start xs:gap-4 xs:px-6">
                <div className="h-fit w-fit rounded-[6px] px-[10px] py-1 bg-gray-666">
                    <p className="text-white m-0 text-[0.75rem] font-semibold">v 8.0.0</p>
                </div>
                <div className="text-[0.9rem] text-text opacity-70">&copy; 2026 Hari Vishnu</div>
            </div>
        </div>
    )
}
